import axios from "axios";
import Api from "../../Api";
import loginService from "../Login_Service";

const formatApiDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
};
const Service = {
    async getBranch() {
        try {

            var MAIN_ACCOUNT_ID = localStorage.getItem("UserID");
            const data = {
                "MAIN_ACCOUNT_ID": MAIN_ACCOUNT_ID
            }
            const response = await axios.post(`${Api}/api/GET_ALL_BRANCH`,
                JSON.stringify(data),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("Token")}`,
                    },
                }
            );

            if (response.status === 200) {
                return { success: true, data: response.data };
            }
        } catch (error) {
            if (error.message === "Request failed with status code 403") {
                await loginService.login(localStorage.getItem("email"), localStorage.getItem("password"));
                window.location.reload();
            }
            return { success: false, error };
        }
    },

    async search(link, page, limit) {
        try {
            let fromdate = localStorage.getItem("FROM_DATE");
            if (!fromdate) {
                fromdate = formatApiDate(Date());
            }

            let todate = localStorage.getItem("TO_DATE");
            if (!todate) {
                todate = formatApiDate(Date());
            }

            let Branch = JSON.parse(localStorage.getItem("BRANCH")) || [];


            var MAIN_ACCOUNT_ID = localStorage.getItem("UserID");

            if (localStorage.getItem("type") !== "MAIN") {
                MAIN_ACCOUNT_ID = localStorage.getItem("MAIN_ACCOUNT_ID");
            }


            const data = {
                "MAIN_ACCOUNT_ID": MAIN_ACCOUNT_ID,
                "BRANCH": Branch,
                "FROM_DATE": fromdate,
                "TO_DATE": todate,
            }
            if (page != null && limit != null) {
                data.PAGE = page;
                data.LIMIT = limit;
            }

            const response = await axios.post(
                `${Api}/api/${link}`,
                data,
                {
                    timeout: 300000,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("Token")}`,
                    },
                }
            );
            if (response.status === 200) {
                return { success: true, data: response.data };
            }
        } catch (error) {
            return { success: false, error: error.message };
        }
    },
};

export default Service;